<template>
  <nav aria-label="breadcrumb">
    <slot />
  </nav>
</template>
<script>
/**
 * Pinta el breadcrumb de la pantalla en la barra superior en lugar de en el
 * contenido. Mueve su propio elemento al hueco #navbar-breadcrumb de
 * TopNavbar; si no lo encuentra, se queda donde está.
 */
export default {
  name: "navbar-breadcrumb",
  data() {
    return { enNavbar: false };
  },
  mounted() {
    const destino = document.getElementById("navbar-breadcrumb");
    if (!destino) return;
    destino.appendChild(this.$el);
    this.enNavbar = true;
  },
  // eslint-disable-next-line vue/no-deprecated-destroyed-lifecycle
  beforeDestroy() {
    if (!this.enNavbar) return;
    if (this.$el.parentNode) this.$el.parentNode.removeChild(this.$el);
  },
};
</script>
